/**
 * Subtitle data lives in project.subtitles[] array.
 * Each subtitle: { id, text, startTime, endTime, style: { fontFamily, fontSize, color } }
 */

export function getActiveSubtitle(subtitles, timeSec) {
  if (!subtitles) return null;
  return subtitles.find(
    s => timeSec >= s.startTime && timeSec < s.endTime
  ) || null;
}

export function createSubtitle(startTime = 0, endTime = 3) {
  return {
    id: `sub-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
    text: 'Type your subtitle here!',
    startTime,
    endTime,
    style: {
      fontFamily: 'Inter, sans-serif',
      fontSize: 24,
      color: '#ffffff',
    },
  };
}
